import { action } from 'mobx';
import debounce from 'lodash/debounce';
import { getIf } from '../data-set/utils';
export default class BatchRunner {
    constructor(batchInterval = 100) {
        this.run = debounce(action((tasks) => {
            tasks.forEach(task => task());
            tasks.clear();
        }), batchInterval);
    }
    addTask(key, callback) {
        this.run(getIf(this, 'task', () => new Map()).set(key, callback));
    }
}
